import { Box, LinearProgress, Sheet, Tooltip, Typography } from "@mui/joy";
import { DataGridPremium } from "@mui/x-data-grid-premium";
import { useGigPieces } from "../../redux/gigPiece/gigPieceHooks";
import { Cover } from "../cover/cover";
import { Outlet, useNavigate, useParams } from "react-router-dom";
import { AppRouter } from "../../appRouter";
import { RouterConfig } from "../config/routerConfig";
import { Toolbar } from "../gigsDatagrid/gigsDatagrid";

/**
 *
 * @returns {ReactElement} GigPiecesDatagrid page
 */
export function GigPiecesDatagrid() {
  const { gigPieces, isLoading } = useGigPieces();
  const navigate = useNavigate();

  return (
    <DataGridPremium
      slots={{
        toolbar: Toolbar,
      }}
      slotProps={{
        toolbar: {
          showQuickFilter: true,
        },
      }}
      pagination
      pageSizeOptions={[25]}
      loading={isLoading}
      rows={gigPieces ?? []}
      columns={[
        {
          field: "sourceID",
          headerName: "",
          width: 12,
          renderCell: (p) =>
            p.value !== 420 ? (
              <Tooltip
                arrow
                size="sm"
                sx={{ maxWidth: 150, textAlign: "center" }}
                variant="outlined"
                title="Thie item cannot be edited. It is controlled by an organization using Rhapsody."
              >
                <i className="fa-solid fa-lock"></i>
              </Tooltip>
            ) : (
              <Box />
            ),
        },
        { field: "name", headerName: "Name", width: 500 },
      ]}
      initialState={{
        pinnedColumns: {
          right: ["completion"],
        },
        pagination: {
          paginationModel: {
            pageSize: 25,
          },
        },
      }}
    />
  );
}
